import { inject, Injectable } from "@angular/core";
import { AppState } from "../../../../store/app.state";
import { Store } from "@ngrx/store";
import { setEndTimer, resetEndTimer } from "../../../../store/timer/timer.actions";

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  store = inject(Store<AppState>);

  private readonly STORAGE_KEY = 'shared_timer_end_at';

  setEndAt(endAtMs: number): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, String(endAtMs));
    } catch {}
  }

  getEndAt(): number | null {
    try {
      const raw = localStorage.getItem(this.STORAGE_KEY);
      return raw ? Number(raw) : null;
    } catch {
      return null;
    }
  }

  clear(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch {}
  }

  start(durationSeconds: number): number {
    const endAt = Date.now() + durationSeconds * 1000;
    this.setEndAt(endAt);
    const remaining = this.getRemainingSeconds();
    this.store.dispatch(setEndTimer({ endTimer: remaining }));
    return remaining;
  }

  getRemainingSeconds(nowMs: number = Date.now()): number {
    const endAt = this.getEndAt();
    if (!endAt) return 0;
    const diff = Math.floor((endAt - nowMs) / 1000);
    return diff > 0 ? diff : 0;
  }

  updateRemaining(remainingSeconds: number): void {
    this.store.dispatch(setEndTimer({ endTimer: remainingSeconds }));
  }

  complete(): void {
    this.clear();
    this.store.dispatch(resetEndTimer());
  }
}